<template>
  <li class="last-activity-item">
    <div class="header">
      <div class="dot" :style="[{backgroundColor: color}]" />
      <h4 @click.prevent="toggleModal">{{ name }}</h4>
    </div>

    <div>
      <span class="action">{{action}}</span>
      <span class="author">{{item.created_by}}</span>
    </div>

    <div>
      <span class="at">at</span>
      <span>{{actionTime}}</span>
    </div>

  </li>
</template>

<script>
  //Config
  import { searchTypes, activityActions, multiSyntaxSearch } from "../../../../config/bool-const";

  //Plugins
  import find from 'lodash/find';
  import moment from 'moment';

export default {
  name: "LastActivityItem",
  props: {
    resourceName: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    action() { return `${activityActions[this.item.action.toUpperCase()]} by`; },
    actionTime() { return moment.utc(this.item.created_at).format('Do MMMM YYYY HH:mm') + ' (UTC)' },
    name () {
      if(['group', 'group_library'].indexOf(this.resourceName) !== -1) {
        return this.item.group_name || 'ID: ' + this.item.group_id;
      }
      else if(['search', 'searches'].indexOf(this.resourceName) !== -1) {
        return this.item.search_title || 'ID: ' + this.item.search_id;
      } else {
        return this.item.tag_name ||  'ID: ' + this.item.tag_id;
      }
    },
    color() {
      if(['group', 'group_library'].indexOf(this.resourceName) !== -1) {
        return '#9CA3AF';
      }
      else if(this.item.is_multi) {
        return multiSyntaxSearch.color;
      }
      else if(['search', 'searches'].indexOf(this.resourceName) !== -1) {
        let searchTypeOptions = find(searchTypes, type => type.value === this.item.search_type);
        return searchTypeOptions?.color && searchTypeOptions?.color.trim() !== '' ? searchTypeOptions.color : '#754cf5';
      } else {
        return '#754cf5';
      }
    }
  },

  methods: {
    toggleModal() {
      this.$store.commit('booleanSearch/SET_ACTIVITY_ACTIVE', this.item)
    }
  }
}
</script>